import { useMemo } from 'react';
import { FieldMetaProps } from 'formik';

export const useErrorText = <T>(fieldMetaProps: FieldMetaProps<T>) =>
  useMemo(() => {
    //error text exists only if field is touched
    if (!fieldMetaProps.touched) {
      return undefined;
    }
    return fieldMetaProps.error;
  }, [fieldMetaProps]);
